import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type PersonFillProps = IconComponentBaseProps;

export const PersonFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: PersonFillProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_8565_176439"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8565_176439)">
        <path
          d="M12 11.6923C11.0347 11.6923 10.21 11.3503 9.526 10.6663C8.842 9.98243 8.5 9.15776 8.5 8.19226C8.5 7.22693 8.842 6.40226 9.526 5.71826C10.21 5.03426 11.0347 4.69226 12 4.69226C12.9653 4.69226 13.79 5.03426 14.474 5.71826C15.158 6.40226 15.5 7.22693 15.5 8.19226C15.5 9.15776 15.158 9.98243 14.474 10.6663C13.79 11.3503 12.9653 11.6923 12 11.6923ZM4.5 17.7885V17.0845C4.5 16.5948 4.633 16.1413 4.899 15.724C5.165 15.3067 5.5205 14.9858 5.9655 14.7615C6.95383 14.277 7.95092 13.9136 8.95675 13.6713C9.96258 13.4289 10.977 13.3078 12 13.3078C13.023 13.3078 14.0374 13.4289 15.0433 13.6713C16.0491 13.9136 17.0462 14.277 18.0345 14.7615C18.4795 14.9858 18.835 15.3067 19.101 15.724C19.367 16.1413 19.5 16.5948 19.5 17.0845V17.7885C19.5 18.2102 19.3523 18.5688 19.0568 18.8645C18.7613 19.16 18.4026 19.3078 17.9808 19.3078H6.01925C5.59742 19.3078 5.23875 19.16 4.94325 18.8645C4.64775 18.5688 4.5 18.2102 4.5 17.7885Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
